import React from 'react';
import { ITableProps } from './interface';
import { withLoading } from './components/with-loading/loading';
import { withPagination } from './components/with-pagination/pagination';
import { composeHoc } from '../utils/compose';
import { withExternalActions } from './components/with-external-actions/exeternal-actions';
import { TableComponent } from './components/table/table';
import { withContainer } from './components/container';
import { withHeader } from './components/with-header/header';
import { withProvider } from './components/with-provider';
import { tablePropsAreEqual } from './memo-utils';

const TableWithoutMemo = composeHoc(
  withProvider,
  withContainer,
  withLoading,
  withHeader,
  withPagination,
  withExternalActions
)(TableComponent);

export const Table: React.FC<ITableProps> = React.memo(
  TableWithoutMemo,
  tablePropsAreEqual
);
